import type { CategoryKind, ChargeKind, DebtStatus, DebtType, InterestRateType, PaymentMethod } from './types';

export const DEBT_TYPE_LABELS: Record<DebtType, string> = {
  REVOLVING: 'Rotativo (tarjeta de crédito)',
  FIXED_INSTALLMENT: 'Cuota fija (amortización francesa)',
};

export const RATE_TYPE_LABELS: Record<InterestRateType, string> = {
  EA: 'Efectivo Anual (E.A.)',
  MV: 'Mes Vencido (M.V.)',
};

export const DEBT_STATUS_LABELS: Record<DebtStatus, string> = {
  ACTIVE: 'Activa',
  PAID_OFF: 'Pagada',
  ARCHIVED: 'Archivada',
};

export const CHARGE_KIND_LABELS: Record<ChargeKind, string> = {
  INTEREST: 'Intereses',
  PURCHASE: 'Compra',
  FEE: 'Cuota de manejo',
  ADJUSTMENT: 'Ajuste de saldo',
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  CASH: 'Efectivo',
  DEBIT: 'Débito',
  CREDIT: 'Crédito',
  TRANSFER: 'Transferencia',
};

export const CATEGORY_KIND_LABELS: Record<CategoryKind, string> = {
  INCOME: 'Ingreso',
  EXPENSE: 'Gasto',
};
